// extracted by mini-css-extract-plugin
module.exports = {"customizationLayout":"Ftbuk","blockTitle":"FQ5ae","splitter":"eYSMg","blockWrapper":"qV4XH","colorPickerWrapper":"_6hqeT","colorPicker":"f4Z-S","partnerSelection":"sWaeI"};